module.exports = __webpack_public_path__ + "media/images/prop-img-1440-765396e3dad35c6d76b289e538b2ca34.svg";